import { InitialBulkActionsFn, InitialParagrafFn, PostEditorInitialFn } from '../../../models/post-editor';
import {
  LinkClickTracking,
  LinkDestination,
  PostFeedType,
  PostQueuePosition,
  PostStatus,
  PostTiming
} from '../../../models/graphql';

export const initialParagraph: InitialParagrafFn = () => ({
  type: 'paragraph',
  children: [{ text: '' }]
});

export const GENERATING_CAPTIONS_PLACEHOLDER = 'Generating…';

export const InitialPostEditorState: PostEditorInitialFn = () => ({
  loading: false,
  shouldValidate: false,
  postGroups: [
    {
      bitlyAccount: {
        profilesWithBitly: [],
        defaultBitly: undefined
      },
      activeCustomizeIndex: null,
      customizeContentPerProfile: false,
      customizeSchedulePerProfile: false,
      groupPostAttributes: {
        content: {
          firstComment: [initialParagraph()],
          link: null,
          media: [],
          postFeedType: PostFeedType.FEED,
          publishMethod: null,
          shouldShowFirstComment: false,
          texts: [{ text: [initialParagraph()], id: 1 }],
          title: null,
          variationMeta: {
            currentVariationIndex: 1,
            prevPostedCount: 0,
            total: 0,
            mediaVariationIndex: null,
            textVariationIndex: null
          },
          varyMedia: null
        },
        scheduling: {
          evergreen: {
            active: false,
            expireType: [],
            expiryDate: null,
            expiryMaxRepeats: null
          },
          postTiming: PostTiming.QUEUE,
          queuePosition: null,
          recurring: {
            active: false,
            date: null,
            expireType: [],
            expiryDate: null,
            expiryMaxRepeats: null
          },
          recurringType: null,
          recurringValue: null,
          scheduledLocalDateTimes: [],
          scheduledTimezone: null
        },
        postSource: null,
        postStatus: PostStatus.ACTIVE,
        customizedProfileId: null,
        postId: null,
        parentId: null
      },
      posts: [],
      readOnlyPosts: [],
      categoryId: null,
      familyUuid: null,
      profiles: [],
      errors: {
        categoryRequired: false,
        checkDateAndTime: false,
        checkDisconectedProfiles: false,
        checkExpiryCount: false,
        checkExpiryDate: false,
        checkLinksPresent: false,
        checkLinkPreviewSuppressed: false,
        checkRecurringInterval: false,
        checkQueuePosition: false,
        expireCountRequired: false,
        expireDateRequired: false,
        facebookContentRequired: false,
        facebookTextCharLimit: false,
        facebookMediaLimit: false,
        facebookTwitterLineBreakLimit: false,
        finishUpload: false,
        googleTextCharLimit: false,
        googleMediaLimit: false,
        googleMinMedia: false,
        instagramFacebookFirstCommentCharLimit: false,
        instagramHashtagLimit: false,
        instagramMediaLimit: false,
        instagramTextCharLimit: false,
        linkedinFirstCommentCharLimit: false,
        linkedinMediaLimit: false,
        linkedinTextCharLimit: false,
        mediaRequired: false,
        noGifsAllowed: false,
        noImagesAllowed: false,
        noMixedMedia: false,
        noVideosAllowed: false,
        pinterestBoardRequired: false,
        pinterestTextCharLimit: false,
        pinterestDuplicatesCheck: false,
        pinterestLineBreakLimit: false,
        pinterestMediaLimit: false,
        preventAudioOnlyFiles: false,
        preventPostNowForDisconnected: false,
        preventTwDuplicate: false,
        profileRequired: false,
        scheduleTextOrMediaVariations: false,
        tikTokAudienceRequired: false,
        tikTokMediaLimit: false,
        tikTokTextCharLimit: false,
        tikTokVideoLength: false,
        tikTokVideoSize: false,
        titleCharLimit: false,
        twitterMediaLimit: false,
        twitterTextCharLimit: false,
        videoNotTranscoded: false
      },
      expanded: true,
      deleted: false
    }
  ],

  isValid: undefined,
  disconnectedProfiles: []
});

export const InitialBulkActions: InitialBulkActionsFn = () => ({
  targeting: {
    hasChanges: false,
    checkboxes: {
      postStatus: false,
      profiles: false,
      category: false,
      instagramPostFeedType: false,
      instagramPublishMethod: false
    },
    content: {
      postStatus: PostStatus.ACTIVE,
      profiles: [],
      category: null,
      instagramPostFeedType: PostFeedType.FEED,
      instagramPublishMethod: null
    }
  },
  linkSettings: {
    hasChanges: false,
    checkboxes: {
      keepExistingUtm: false,
      addUtmCampaignTracking: false,
      bitly: false,
      linkDestination: false
    },
    content: {
      keepExistingUtm: true,
      addUtmCampaignTracking: false,
      utmSettings: {
        source: '',
        medium: '',
        campaign: '',
        term: '',
        content: ''
      },
      bitly: LinkClickTracking.NONE,
      linkDestination: LinkDestination.INITIAL
    }
  },
  scheduling: {
    hasChanges: false,
    checkboxes: {
      positionInQueue: false,
      evergreenRecycle: false
    },
    content: {
      positionInQueue: PostQueuePosition.TOP,
      evergreenRecycle: {
        active: false,
        expireType: [],
        expiryDate: null,
        expiryMaxRepeats: null
      }
    }
  }
});
